'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import moment from 'moment';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reactRedux = require('react-redux');

var _support = require('helpers/support');

var _reactRouter = require('react-router');

var _lodash = require('lodash');

var _FirebaseAuth = require('helpers/FirebaseAuth');

var _FirebaseAuth2 = _interopRequireDefault(_FirebaseAuth);

var _voucher = require('redux/modules/voucher');

var vouchersAction = _interopRequireWildcard(_voucher);

var voucherActions = _interopRequireWildcard(_voucher);

var _analytics = require('redux/modules/analytics');

var analyticsActions = _interopRequireWildcard(_analytics);

var _components = require('components');

var _setup = require('redux/modules/setup');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const CAMPAIGN_FIELD = [
//   'name',
//   'typeVoucher',
//   'code',
//   'startDate',
//   'endDate',
//   'condition',
//   'userUsed',
// ];
var StepTwo = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    submit: state.booking.submit,
    groupServices: state.booking.groupServices,
    pricing: state.booking.pricing,
    isPricing: state.booking.isPricing,
    couponData: state.booking.couponData,
    services: state.booking.services,
    MY_REWARD_LIST: state.voucher.MY_REWARD_LIST
  };
}, (0, _extends3.default)({}, vouchersAction, {
  loadService: bookingActions.loadService,
  loadAllCoupon: bookingActions.loadAllCoupon,
  changeAmount: bookingActions.changeAmount,
  changeService: bookingActions.changeService,
  changeNote: bookingActions.changeNote,
  changeCoupon: bookingActions.changeCoupon,
  removeCoupon: bookingActions.removeCoupon,
  totalAmount: bookingActions.totalAmount,
  resetPricing: bookingActions.resetPricing,
  setSubmit: bookingActions.setSubmit,
  changeCode: bookingActions.changeCode,
  loginPhone: authActions.loginPhone,
  getMyReward: voucherActions.getMyReward,
  manualTrack: analyticsActions.manualTrack,
  setPathName: _setup.setPathName
})), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(StepTwo, _Component);

  function StepTwo() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, StepTwo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StepTwo.__proto__ || (0, _getPrototypeOf2.default)(StepTwo)).call.apply(_ref, [this].concat(args))), _this), _this.applyCode = false, _this.trySubmit = false, _this.state = {
      code: '',
      showInfo: false,
      info: { title: {}, message: [] },
      showPromotion: false,
      FooterUI: {
        label: 'Tổng giá tiền tạm tính',
        btnLabel: 'TIẾP THEO'
      }
    }, _this.toAllReward = function () {
      _this.props.changeTab('allReward');
      _this.props.history.push('/uu-dai');
    }, _this.responsePhone = function (response) {
      if (response) {
        _this.props.loginPhone(response);
      }
    }, _this.trackingData = function () {
      var _this$props$submit = _this.props.submit,
          shop = _this$props$submit.shop,
          code = _this$props$submit.code,
          bookingServices = _this$props$submit.bookingServices;

      var track = {
        code: code,
        shopId: shop.id
      };
      if (bookingServices && bookingServices.length) {
        track.serviceId = bookingServices.reduce(function (result, bService) {
          return bService.number > 0 ? [].concat((0, _toConsumableArray3.default)(result), [bService.service]) : result;
        }, []);
      }
      return track;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  // Cờ kiểm tra code nhập đã apply hay chưa?

  // Cờ để gọi lại nextStep


  (0, _createClass3.default)(StepTwo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave(nextState) {
      if (nextState.action === 'POP' && this.state.showPromotion) {
        this.hidePromotion();
        return false;
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props$submit = this.props.submit,
          shopId = _props$submit.shop._id,
          bookingTimeId = _props$submit.bookingTimeId,
          code = _props$submit.code,
          bookingServices = _props$submit.bookingServices;
      var _props2 = this.props,
          setSubmit = _props2.setSubmit,
          services = _props2.services;

      var bookings = [].concat((0, _toConsumableArray3.default)(this.props.submit.bookingServices));
      bookings = bookings.filter(function (v) {
        return v.number > 0;
      });
      if (bookings.length) {
        bookings.forEach(function (v, i) {
          if (!_support.Helper.serviceIsExist(v.service, services)) {
            bookings.splice(i, 1);
          }
        });
        if (bookingServices.length !== bookings.length) {
          setSubmit('bookingServices', bookings);
        }
      }
      var body = { bookingTimeId: bookingTimeId, bookingServices: bookings, shopId: shopId };
      if (code) {
        body.code = code;
      }
      var _props3 = this.props,
          getMyReward = _props3.getMyReward,
          totalAmount = _props3.totalAmount;

      if (bookings && bookings.length) {
        totalAmount(body);
      }
      // loadService(shopId);
      getMyReward();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // TODO: Pricing khi: thay đổi bookingTime, thay đổi service, remove service, thay đổi mã giảm giá, remove mã giảm giá.
      var _props4 = this.props,
          totalAmount = _props4.totalAmount,
          resetPricing = _props4.resetPricing;

      if (nextProps.submit.bookingTimeId !== undefined && nextProps.submit.bookingTimeId !== this.props.submit.bookingTimeId || !(0, _lodash.isEqual)(nextProps.submit.bookingServices, this.props.submit.bookingServices) || nextProps.submit.code !== this.props.submit.code) {
        var _nextProps$submit = nextProps.submit,
            bookingTimeId = _nextProps$submit.bookingTimeId,
            code = _nextProps$submit.code,
            shopId = _nextProps$submit.shop._id;

        var bookingServices = [].concat((0, _toConsumableArray3.default)(nextProps.submit.bookingServices));
        bookingServices = bookingServices.filter(function (v) {
          return v.number > 0;
        });
        var body = { bookingTimeId: bookingTimeId, bookingServices: bookingServices, shopId: shopId };
        if (code) {
          body.code = code;
        }
        if (nextProps.submit.bookingServices.length === 0) {
          resetPricing();
        }
        totalAmount(body);
      }
      if (this.props.isPricing !== nextProps.isPricing && !nextProps.isPricing) {
        // Hoàn thành tính tiền thì vào đây.
        if (this.trySubmit) {
          this.nextStep(nextProps);
          this.trySubmit = false;
        }
      }
    }
    // Thay đổi số lượng slot

  }, {
    key: 'onChangeAmount',
    value: function onChangeAmount(number, _, type) {
      var _props5 = this.props,
          changeAmount = _props5.changeAmount,
          _props5$submit = _props5.submit,
          time = _props5$submit.time,
          slot = _props5$submit.slot;

      if (type === 'decrease' && number === slot && number === 1) {
        var title = { text: 'Thông Báo', type: 'info' };
        var message = [{ text: 'Bạn phải chọn ít nhất một chỗ!' }];
        var info = { title: title, message: message };
        this.setState({ info: info, showInfo: true });
      } else if (slot === time.empty && number === slot) {
        var _title = { text: 'Thông Báo', type: 'info' };
        var _message = [{ text: 'Không có đủ số lượng chỗ trống cho khung giờ này!' }];
        var _info = { title: _title, message: _message };
        this.setState({ info: _info, showInfo: true });
      } else {
        changeAmount(number);
      }
    }
    // Thay đổi số lượng dịch vụ.

  }, {
    key: 'onChangeService',
    value: function onChangeService(number, item) {
      var changeService = this.props.changeService;

      var service = { service: item._id, number: number, name: item.name };
      changeService(service);
    }
  }, {
    key: 'onChangeNote',
    value: function onChangeNote(noteByUser) {
      var changeNote = this.props.changeNote;

      changeNote(noteByUser);
    }
  }, {
    key: 'onRemoveCoupon',
    value: function onRemoveCoupon() {
      var _props6 = this.props,
          removeCoupon = _props6.removeCoupon,
          user = _props6.user;

      if (user) {
        console.log('vào removeCoupon');
        var couponData = {
          type: 'default',
          name: 'Nhập mã giảm giá',
          leftIcon: '/booking/discount.png'
        };
        this.setState({ code: '', couponData: couponData });
        removeCoupon();
      } else {
        console.log('vào yêu cầu đăng nhập');
        this.alertLogin();
      }
    }
  }, {
    key: 'onChangeCoupon',
    value: function onChangeCoupon(coupon) {
      var changeCoupon = this.props.changeCoupon;

      changeCoupon(coupon);
      this.applyCode = false;
      this.hidePromotion();
    }
  }, {
    key: 'onApplyCoupon',
    value: function onApplyCoupon() {
      // TODO: gọi api checkValidCoupon
      var code = this.state.code;
      var changeCode = this.props.changeCode;

      if (code) {
        this.applyCode = true;
        changeCode(code);
      }
    }
  }, {
    key: 'onChangeCode',
    value: function onChangeCode(e) {
      var text = e.target.value;
      if (this.applyCode) {
        this.applyCode = false;
      }
      this.setState({ code: text });
    }
  }, {
    key: 'showPromotion',
    value: function showPromotion() {
      var _this2 = this;

      var _props7 = this.props,
          data = _props7.MY_REWARD_LIST.data,
          user = _props7.user,
          manualTrack = _props7.manualTrack;

      if (user) {
        if (data && data.length > 0) {
          this.setState({ showPromotion: true });
        } else {
          var title = { text: 'Thông Báo', type: 'info' };
          var message = [{ text: 'Bạn chưa có vouchers nào' }];
          var button = [{
            text: 'OK',
            onClick: function onClick() {
              return _this2.hideInfo();
            }
          }, {
            text: 'Xem ưu đãi',
            onClick: this.toAllReward
          }];
          var info = { title: title, message: message, button: button };
          this.setState({ showInfo: true, info: info });
        }
      } else {
        this.alertLogin();
      }
      manualTrack({ screen: 'StepTwo', button: 'View More Voucher' });
    }
  }, {
    key: 'alertLogin',
    value: function alertLogin() {
      var _this3 = this;

      var title = { text: 'Thông Báo', type: 'info' };
      var message = [{ text: 'Bạn cần phải đăng nhập để sử dụng tính năng này!' }];
      var button = [{
        text: 'Đăng Nhập',
        onClick: function onClick() {
          if (_this3.loginFirebase) {
            _this3.loginFirebase.click();
          }
          _this3.hideInfo();
        }
      }, {
        text: 'Thoát',
        type: 'default',
        onClick: function onClick() {
          return _this3.hideInfo();
        }
      }];
      var info = { title: title, message: message, button: button };
      this.setState({ info: info, showInfo: true });
    }
  }, {
    key: 'hidePromotion',
    value: function hidePromotion() {
      // this.props.history.goBack();
      this.setState({ showPromotion: false });
    }
  }, {
    key: 'hideInfo',
    value: function hideInfo() {
      this.setState({ showInfo: false });
    }
  }, {
    key: 'nextStep',
    value: function nextStep(nextProps) {
      var _this4 = this;

      console.log('nextProps', nextProps);
      var _props = this.props;
      if (nextProps) {
        _props = nextProps;
      }
      var code = this.state.code;
      var _props8 = _props,
          _props8$submit = _props8.submit,
          bookingServices = _props8$submit.bookingServices,
          slot = _props8$submit.slot,
          shop = _props8$submit.shop,
          couponData = _props8.couponData;


      var totalServices = 0;
      bookingServices.map(function (v) {
        return totalServices += v.number;
      });
      var title = { text: 'Thông Báo', type: 'info' };
      // Kiểm tra code nhập
      if (code && !this.applyCode) {
        // const title = { text: 'Thông Báo', type: 'info' };
        var message = [{ text: 'Bạn có muốn tiếp tục với mã code bạn đã nhập?' }];
        var button = [{
          type: 'default',
          text: 'Thoát',
          onClick: function onClick() {
            _this4.hideInfo();
          }
        }, {
          text: 'Tiếp Tục',
          onClick: function onClick() {
            _this4.hideInfo();
            _this4.onApplyCoupon();
            _this4.trySubmit = true;
          }
        }];
        var info = { title: title, message: message, button: button };
        this.setState({ info: info, showInfo: true });
        return;
      }
      // Kiểm tra số lượng slots và số lượng dịch vụ.
      if (slot > totalServices) {
        var _message2 = [{ text: 'Vui lòng kiểm tra lại số lượng chỗ và số lượng dịch vụ.' }];
        var _info2 = { title: title, message: _message2 };
        this.setState({ info: _info2, showInfo: true });
        return;
      } else if (couponData.type === 'inactive') {
        var _message3 = [{ text: 'Mã giảm giá không hợp lệ.' }];
        var _button = [{
          text: 'Xóa Mã Giảm Giá',
          onClick: function onClick() {
            _this4.hideInfo();
            _this4.onRemoveCoupon();
          }
        }];
        var _info3 = { title: title, message: _message3, button: _button };
        this.setState({ info: _info3, showInfo: true });
        return;
      }
      this.props.history.push('/dat-lich-3');
      _reactGa2.default.event({
        category: 'Booking',
        action: 'Clicked To Step 3',
        label: '' + shop.name
      });
    }
  }, {
    key: 'renderService',
    value: function renderService(services, last) {
      var _this5 = this;

      var bookingServices = this.props.submit.bookingServices;

      return services.map(function (service, i) {
        var index = '';
        var border = true;
        if (i === services.length - 1) {
          border = false;
          if (last) {
            index = 'last';
          }
        }
        var number = 0;
        bookingServices.map(function (v) {
          if (v.service === service._id || v.service === service.service) {
            number = v.number;
          }
        });
        var data = {
          primary: service.name,
          extra: _support.Helper.formatMoney(service.price),
          item: service,
          number: 0
        };
        return _react2.default.createElement(_components.StepInput, {
          tracking: { screen: 'StepTwo', button: 'Change Service' },
          manualTrack: _this5.props.manualTrack,
          data: data,
          number: number,
          onChange: _this5.onChangeService.bind(_this5),
          key: service.category + '_' + i,
          index: index,
          border: border
        });
      });
    }
  }, {
    key: 'renderServiceCardBooking',
    value: function renderServiceCardBooking() {
      var _props9 = this.props,
          bookingServices = _props9.submit.bookingServices,
          services = _props9.services;
      // console.warn('renderServiceCardBooking', bookingServices, services);

      if (bookingServices && bookingServices.length) {
        var ser = services.find(function (v) {
          return v._id === bookingServices[0]._id;
        });
        // console.log('service :', ser);
        return _react2.default.createElement(_components.ServiceCardBooking, { data: ser });
      }
      return null;
    }
  }, {
    key: 'renderExpand',
    value: function renderExpand() {
      var _this6 = this;

      var _props10 = this.props,
          groupServices = _props10.groupServices,
          bookingServices = _props10.submit.bookingServices;
      // console.log('renderExpand', groupServices);

      if (groupServices) {
        // Check bookingService exist in groupServices to push that groupService to top
        // groupServices.map((item, i) => {
        //   let bookingService = '';
        //   if (bookingServices && bookingServices.length) {
        //     bookingService = bookingServices[0].service;
        //   }
        //   if (
        //     bookingService &&
        //     item.services.findIndex(v => v._id === bookingService) !== -1
        //   ) {
        //     groupServices.splice(i, 1);
        //     groupServices.unshift(item);
        //   }
        // });
        return groupServices.map(function (item, i) {
          var show = false;
          var index = '';
          if (i === 0) {
            index = 'first';
            show = true;
          }
          if (i === groupServices.length - 1) {
            index = 'last';
          }
          if (groupServices.length === 1) {
            index = 'one';
          }
          if (bookingServices && bookingServices.length) {
            show = _support.Helper.isExpand(item.services, bookingServices);
          }
          var object = {
            titleLeft: item.category.label,
            titleRight: item.numberService + ' d\u1ECBch v\u1EE5',
            show: show,
            index: index,
            key: 'expand_' + i
          };
          return _react2.default.createElement(
            _components.Expand,
            (0, _extends3.default)({ key: 'expand_' + i }, object),
            _this6.renderService(item.services, i === groupServices.length - 1)
          );
        });
      }
    }
  }, {
    key: 'renderItem',
    value: function renderItem(coupon, index) {
      var _this7 = this;

      var shopId = this.props.submit.shop._id;

      var card = _support.Helper.parseCouponToCard(coupon, shopId);
      return _react2.default.createElement(_components.PCardBooking, {
        key: 'coupon_' + index,
        card: card,
        onChange: function onChange() {
          return _this7.onChangeCoupon(coupon);
        }
      });
    }
  }, {
    key: 'renderCampaign',
    value: function renderCampaign() {
      var _this8 = this;

      var data = this.props.MY_REWARD_LIST.data;

      if (data && data.length) {
        return data.map(function (v, i) {
          return _this8.renderItem(v, i);
        });
      }
    }
  }, {
    key: 'updateFooterUI',
    value: function updateFooterUI() {
      var pricing = this.props.pricing;

      return pricing.total === pricing.totalCost ? (0, _extends3.default)({}, this.state.FooterUI, { main: pricing.total }) : (0, _extends3.default)({}, this.state.FooterUI, { main: pricing.total, sub: pricing.totalCost });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var styles = require('./StepTwo.scss');
      var _props11 = this.props,
          _props11$submit = _props11.submit,
          slot = _props11$submit.slot,
          time = _props11$submit.time,
          noteByUser = _props11$submit.noteByUser,
          shop = _props11$submit.shop,
          couponData = _props11.couponData,
          user = _props11.user;
      var _state = this.state,
          showPromotion = _state.showPromotion,
          showInfo = _state.showInfo,
          info = _state.info;

      var FooterUI = this.updateFooterUI();
      var tracking = this.trackingData();
      return _react2.default.createElement(
        'div',
        { className: styles.container },
        _react2.default.createElement(
          'div',
          { className: styles.content },
          shop.shopType !== 'freelance' && _react2.default.createElement(
            'div',
            { className: styles.block },
            _react2.default.createElement(_components.StepInput, {
              index: 'one',
              number: slot,
              data: {
                primary: 'Số lượng chỗ',
                number: slot,
                min: 1,
                max: time && time.empty ? time.empty : null
              },
              onChange: this.onChangeAmount.bind(this)
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.block },
            _react2.default.createElement(
              'label',
              null,
              'D\u1ECBch v\u1EE5'
            ),
            shop.shopType === 'freelance' ? this.renderServiceCardBooking() : this.renderExpand()
          ),
          _react2.default.createElement(
            'div',
            { className: styles.block },
            _react2.default.createElement(
              'label',
              null,
              'Ghi ch\xFA '
            ),
            _react2.default.createElement(_components.Note, { value: noteByUser, onChange: this.onChangeNote.bind(this) })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.block },
            _react2.default.createElement(
              'label',
              null,
              '\xC1p d\u1EE5ng khuy\u1EBFn m\xE3i'
            ),
            _react2.default.createElement(_components.CodeCard, (0, _extends3.default)({
              tracking: tracking,
              manualTrack: this.props.manualTrack
            }, couponData, {
              value: this.state.code,
              onChangeCode: this.onChangeCode.bind(this),
              onRemove: this.onRemoveCoupon.bind(this),
              onClick: this.onApplyCoupon.bind(this)
            })),
            _react2.default.createElement(
              'div',
              { className: styles.myCoupon, onClick: this.showPromotion.bind(this) },
              'Ho\u1EB7c ch\u1ECDn m\xE3 gi\u1EA3m gi\xE1 c\u1EE7a b\u1EA1n',
              ' ',
              _react2.default.createElement(
                'span',
                { className: styles.here },
                't\u1EA1i \u0111\xE2y.'
              )
            ),
            !user && _react2.default.createElement(
              _FirebaseAuth2.default,
              { onResponse: this.responsePhone },
              function (p) {
                return _react2.default.createElement(
                  'div',
                  (0, _extends3.default)({
                    ref: function ref(btn) {
                      return _this9.loginFirebase = btn;
                    }
                  }, p, {
                    className: styles.hidden
                  }),
                  '\u0110\u0103ng Nh\u1EADp'
                );
              }
            )
          ),
          _react2.default.createElement(
            _components.ModalCustom,
            {
              full: true,
              title: { text: 'Chọn mã giảm giá' },
              closeButton: true,
              show: showPromotion,
              onHide: this.hidePromotion.bind(this)
            },
            _react2.default.createElement(
              'div',
              { className: styles.modalBody },
              this.renderCampaign()
            )
          ),
          _react2.default.createElement(_components.ModalCustom, {
            closeButton: true,
            show: showInfo,
            onHide: this.hideInfo.bind(this),
            title: info.title,
            message: info.message,
            button: info.button
          })
        ),
        _react2.default.createElement(_components.FooterBooking, { tracking: (0, _extends3.default)({}, tracking, { button: 'Continue' }), manualTrack: this.props.manualTrack, data: FooterUI, onClick: function onClick() {
            return _this9.nextStep();
          } })
      );
    }
  }]);
  return StepTwo;
}(_react.Component), _class2.propTypes = {
  // @action
  loadService: _react.PropTypes.func,
  loadAllCoupon: _react.PropTypes.func,
  changeAmount: _react.PropTypes.func,
  changeService: _react.PropTypes.func,
  changeNote: _react.PropTypes.func,
  changeCoupon: _react.PropTypes.func,
  removeCoupon: _react.PropTypes.func,
  totalAmount: _react.PropTypes.func,
  resetPricing: _react.PropTypes.func,

  setPathName: _react.PropTypes.func,
  loginPhone: _react.PropTypes.func,
  setSubmit: _react.PropTypes.func,
  getMyReward: _react.PropTypes.func,
  changeTab: _react.PropTypes.func,
  changeCode: _react.PropTypes.func,
  manualTrack: _react.PropTypes.func,
  // @data
  groupServices: _react.PropTypes.array,

  pricing: _react.PropTypes.object,
  user: _react.PropTypes.object,
  couponData: _react.PropTypes.object,
  submit: _react.PropTypes.object,
  history: _react.PropTypes.object,
  route: _react.PropTypes.object,
  router: _react.PropTypes.object,
  MY_REWARD_LIST: _react.PropTypes.object,
  // services này chỉ dùng để kiểm tra bookingServices thui, ngoài ra không dùng làm gì cả
  services: _react.PropTypes.array,
  isPricing: _react.PropTypes.bool
}, _temp2)) || _class);
exports.default = (0, _reactRouter.withRouter)(StepTwo);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Booking/StepTwo.js
// module id = 1536
// module chunks = 0